<div class="page-title animatedBackground">
    <div class="container">
        <h3>Services</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Services</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="services-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-automation"></i>
                    </div>
                    <h3>Odoo Customization and Support</h3>
                    <p>Odoo Customization for Any Business - Any Industries</p>
                    <a routerLink="/odoo-customization-and-support-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-dashboard-web"></i>
                    </div>
                    <h3>Web Application Development</h3>
                    <p>Leading-edge web development services to fuel your business growth</p>
                    <a routerLink="/web-application-development-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-stock-mobile"></i>
                    </div>
                    <h3>Mobile Application Development</h3>
                    <p>Building beautiful applications right from imagination</p>
                    <a routerLink="/mobile-application-development-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-shopping-cart"></i>
                    </div>
                    <h3>Ecommerce Development</h3>
                    <p>End-to-end ecommerce development services in any framework</p>
                    <a routerLink="/ecommerce-development-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-code"></i>
                    </div>
                    <h3>Custom Development</h3>
                    <p>Custom Development for any requirement in any framework</p>
                    <a routerLink="/custom-development-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-cloudapp"></i>
                    </div>
                    <h3>Cloud Services and Cyber Security</h3>
                    <p>Cloud Services and Cyber Security is essential need of every organization</p>
                    <a routerLink="/cloud-server-and-cyber-securities-service" class="read-more-btn">Read More</a>
                </div>
            </div>
        </div>
    </div>
</section>

